// Generated from scripts/copy-to-clipboard.ts. Rebuild with pnpm scripts:build.
import { Component } from '@theme/component';
/**
 * Copies the text in `text-to-copy` to the clipboard when `copyToClipboard` is called, as the gift card page's
 * button does through `on:click="/copyToClipboard"` and the share block does from its own click handler. The
 * method settles with whether the text was copied: the Clipboard API is missing outside a secure context and
 * refuses without permission, so a copy can fail, and the caller decides how to say so.
 *
 * Contract kept from the inherited module: the `copy-to-clipboard-component` element, the `text-to-copy`
 * attribute, the `copyToClipboard` method and the `copySuccessMessage` ref, whose `visually-hidden` class a
 * successful copy removes. The inherited module let a refused copy surface as an unhandled rejection and never
 * said whether it had copied; the method now returns that.
 */
export class CopyToClipboardComponent extends Component {
    async copyToClipboard() {
        const text = this.getAttribute('text-to-copy');
        if (!text)
            return false;
        try {
            await navigator.clipboard.writeText(text);
        }
        catch {
            return false;
        }
        const { copySuccessMessage } = this.refs;
        if (copySuccessMessage instanceof Element)
            copySuccessMessage.classList.remove('visually-hidden');
        return true;
    }
}
if (!customElements.get('copy-to-clipboard-component')) {
    customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
